import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function updateStockAdjustmentRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/ims/stock-adjustment/${id}/remark`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
